import { render, staticRenderFns } from "./postDetail.vue?vue&type=template&id=a67d8ae4&scoped=true"
import script from "./postDetail.vue?vue&type=script&lang=js"
export * from "./postDetail.vue?vue&type=script&lang=js"
import style0 from "./postDetail.vue?vue&type=style&index=0&id=a67d8ae4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67d8ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67d8ae4')) {
      api.createRecord('a67d8ae4', component.options)
    } else {
      api.reload('a67d8ae4', component.options)
    }
    module.hot.accept("./postDetail.vue?vue&type=template&id=a67d8ae4&scoped=true", function () {
      api.rerender('a67d8ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/postDetail.vue"
export default component.exports